import {graphql} from 'react-apollo';
import gql from 'graphql-tag';

import Contents from '../components/Contents';
import config from '../config';

const ContentsQuery = gql`
  query searchContents($input: SearchContentInput!) {
    searchContents(input: $input) {
      _id
      title
      slug
      type
    }
  }
`;
const ContentsQueryConfig = {
  options: ({match}) => {
    return {
      variables: {input: {project: config.getProjectKey(), limit: 5000}},
      fetchPolicy: 'network-only',
    };
  },
};

export default graphql(ContentsQuery, ContentsQueryConfig)(Contents);



// WEBPACK FOOTER //
// ./src/containers/ContentsPage.js